import React, { Component } from "react";
import RechargeViewH5 from './h5';
import lang from '../../lang';
import {ImageView, Grade, VIP} from '../../component/user-ui';

class RechargeView extends Component {
	static defaultProps ={
		type: 'page' // page，pop
	}

	constructor(props){
		super(props);
		
		let diamond = UP.Global.getUser().balance.diamond;

		this.state = {
			diamondBanlance: diamond,
			isLoggedIn: 0
		}
	}

	componentDidMount() {
		if (UP.Global.isRegisterRealUser() && UP.Global.getUserToken()) {
            this.setState({
                isLoggedIn: 1
            })
        }
        UP.Global.DA.add({
            eventName: 'UplivePayment',
            action: 'View',
            label: 'view'           
        });
        
        window.scrollTo(0, 0);

    }
    login=() =>{
		$.channel.emit('login');
	}
    
    render() {
		let $recharge;
		let countryCode = UP.Global.getUser().countryCode; // 当前用户的国家码
        let userInfo = UP.Global.getUser();
        
		$recharge = <RechargeViewH5/>

        return (
        	<div className="recharge-box">
				<h2>{lang.template('账户充值')}</h2>
				<div className="recharge-content" data-type={this.props.type} id="rechargeScroller">
					{
						this.state.isLoggedIn ? (
							<div className="recharge-content-hd">
								<div className="avatar" ref="avatar">
									<ImageView src={userInfo.avatar} size={30} circle/>
								</div>
								<div className="user-name">
									<div>{userInfo.username}</div>
									<div className="uzuan">
										<label>{lang.template('剩余U钻')}  </label>
										<em>{this.state.diamondBanlance}</em>
			                            <i></i>
		                            </div>
									</div>
								</div>

						) : (
							<div className="recharge-content-hd">
								<div className="avatar" ref="avatar">
									<ImageView  size={30} circle/>
								</div>
								<div className="user-name">

									<p className="login-tip" onClick={this.login.bind(this)}>
        								<label className="r-tip" dangerouslySetInnerHTML={{__html:lang.template("<em>登录</em>之后即可进行充值")}}></label>
			                        </p>
		                         
								</div>

								
							</div>
						)
					}
					
					<div className="recharge-content-bd">
						{$recharge}
					</div>
				</div>
			</div>
        )
    }
}

export default RechargeView;


// WEBPACK FOOTER //
// ./js/mall/recharge/index.js